export default {
    Notifications: 'Notifications',
    SoundAlert: 'Sound Alert',
    SoundAlert_Summary: 'Activate this option if you want to hear a sound alert when a new event is released on the Calendar.',
    Configure_View_Title: 'Configure View',
    ConfigureView_Summary: 'Choose between an advance view or a more simple one suitable for new traders. Be careful, your saved filters will be reset.',
    Configure_View_Default: 'Default',
    Configure_View_Basic: 'Basic',
    Configure_View_Premium: 'Premium',
    Configure_View_Default_Summary: 'All default events with deviation index when actual data differs from consensus',
    Configure_View_Basic_Summary: 'Most impactful events for the market with clear and easy information',
    Configure_View_Premium_Summary: 'Coming soon!',
    Premium_More_Info: 'I want to know more'
}
